import React from 'react';

const UrologicalConditions = () => {
  const conditions = [
    {
      title: "Kidney Stones",
      description: "Kidney stones, though painful, can be effectively managed with minimally invasive procedures.",
      image: "https://domf5oio6qrcr.cloudfront.net/medialibrary/9795/GettyImages-843352558.jpg"
    },
    {
      title: "Prostate Enlargement",
      description: "Find relief from BPH symptoms with tailored treatment options.",
      image: "https://swsurology.com.au/wp-content/uploads/2020/06/enlargedProstate.jpg"
    },
    {
      title: "Urinary Tract Infections",
      description: "Quick diagnosis and antibiotic treatment for UTIs.",
      image: "https://as2.ftcdn.net/jpg/10/62/82/83/1000_F_1062828389_Hc3PfyObutqTjHmL2x6mA6qkYqOOkL6l.jpg"
    },
    {
      title: "Bladder Cancer",
      description: "Personalized treatments for recovery and remission.",
      image: "https://tse3.mm.bing.net/th/id/OIP.SKOFrR67kG0Aot3k3ZjBhAHaGt?rs=1&pid=ImgDetMain&o=7&rm=3"
    },
    {
      title: "Erectile Dysfunction",
      description: "Regain confidence with ED treatments for your lifestyle.",
      image: "https://tse4.mm.bing.net/th/id/OIP.MAWUEz7SoKLXOFrEIUoATgHaEU?rs=1&pid=ImgDetMain&o=7&rm=3"
    },
    {
      title: "Incontinence",
      description: "Manage urinary incontinence for an active life.",
      image: "https://omkarurologyhospital.com/wp-content/uploads/2023/09/Untitled-design-19.png.webp"
    },
    {
      title: "Testicular Cancer",
      description: "Early detection and comprehensive treatment.",
      image: "https://omkarurologyhospital.com/wp-content/uploads/2023/09/Untitled-design-20.png.webp"
    },
    {
      title: "Interstitial Cystitis",
      description: "Relieve discomfort with medical interventions.",
      image: "https://tse4.mm.bing.net/th/id/OIP.g2hyO2xV-KLMFgC5Kr-gdQHaF9?rs=1&pid=ImgDetMain&o=7&rm=3"
    },
    {
      title: "Overactive Bladder",
      description: "Control OAB symptoms with personalized plans.",
      image: "https://www.scientificanimations.com/wp-content/uploads/2017/02/Overactive-Bladder-3D-Medical-Animation.jpg"
    },
    {
      title: "Peyronie's Disease",
      description: "Discover treatments to restore sexual function.",
      image: "https://omkarurologyhospital.com/wp-content/uploads/2023/09/Untitled-design-24.png.webp"
    }
  ];

  return (
    <section className="py-8 md:py-12 bg-gradient-to-br from-sky-50 to-white">
      <div className="container mx-auto px-3 md:px-6">
        
        {/* Header Section - Made more compact */}
        <div className="text-center mb-6 md:mb-8">
          <h1 className="text-xl md:text-2xl font-bold text-gray-800 mb-1">
            UROLOGICAL CONDITIONS
          </h1>
          <div className="w-12 h-0.5 bg-gradient-to-r from-blue-500 to-cyan-400 mx-auto mb-2"></div>
          <h2 className="text-base md:text-lg font-semibold text-gray-700 mb-2">
            Comprehensive Urological Care
          </h2>
          <p className="text-gray-600 text-xs md:text-sm max-w-2xl mx-auto">
            Complete diagnostics, treatment, and support for all urological health issues.
          </p>
        </div>

        {/* Main Card Container - One Big Card */}
        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-100 mb-6">

          {/* Conditions Grid Inside Card - 5 per row */}
          <div className="p-4 md:p-6">
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4">
              {conditions.map((condition, index) => (
                <div 
                  key={index} 
                  className="bg-gray-50 rounded-lg border border-gray-200 hover:border-blue-300 hover:shadow-sm transition-all duration-200 overflow-hidden group"
                >
                  {/* Condition Image */}
                  <div className="h-20 md:h-24 overflow-hidden bg-gray-100">
                    <img 
                      src={condition.image}
                      alt={condition.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                      loading="lazy"
                    />
                  </div>

                  {/* Content */}
                  <div className="p-3">
                    <h4 className="text-xs md:text-sm font-bold text-gray-800 mb-1 line-clamp-1">
                      {condition.title}
                    </h4>
                    <p className="text-gray-600 text-xs mb-2 line-clamp-2">
                      {condition.description}
                    </p>
                    
                    <div className="flex justify-between items-center">
                      <span className="text-[10px] text-gray-500 bg-gray-100 px-1.5 py-0.5 rounded">
                        Treatment
                      </span>
                      <button className="text-[10px] md:text-xs text-blue-600 hover:text-blue-800 font-medium">
                        Read →
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UrologicalConditions;